import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Container, Row, Col, Button, Form, Input } from "reactstrap";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { FormattedMessage } from "react-intl";
import { config } from "./../../constants/domainConfig";

import { console_log } from "../../utils/helper";
import { getLogo, isAfricatv } from "../../constants/multiDomains";
class StaticPages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "",
    };
  }

  componentWillMount() {
    switch (this.props.location.pathname) {
      case "/about":
        this.props.setHeaderTitle("About Us");
        this.setState({
          type: "about",
        });
        break;
      case "/privacy-policy":
        if ("")
          //this.props.setHeaderTitle(ppHead);
          this.setState({
            type: "privacy-policy",
          });
        break;
      case "/terms-conditions":
        this.props.setHeaderTitle("Terms And Conditions");
        this.setState({
          type: "terms-conditions",
        });
        break;
    }
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1000);
  }

  componentDidMount() {
    document.body.classList.add("gradient-bg");
    window.scrollTo(0, 0);
    const privacy = {
      en: "Privacy Policy",
      pt: "Política de Privacidade",
      no: "Retningslinjer for personvern",
      ar: "سياسة الخصوصية",
      ee: "Privaatsuse õigused",
      es: "Privacy Policy",
      el: "Πολιτική Απορρήτου",
      id: "Kebijakan Privasi",
      si: "Politika zasebnosti",
      pl: "Polityka Prywatności",
    };
    this.props.setHeaderTitle(privacy[config.lang]);
  }

  componentWillReceiveProps(nextProps) {
    switch (nextProps.location.pathname) {
      case "/about":
        nextProps.setHeaderTitle("About Us");
        this.setState({
          type: "about",
        });
        break;
      case "/privacy-policy":
        //nextProps.setHeaderTitle(ppHead);
        this.setState({
          type: "privacy-policy",
        });
        break;
      case "/terms-conditions":
        nextProps.setHeaderTitle("Terms And Conditions");
        this.setState({
          type: "terms-conditions",
        });
        break;
    }
    if (this.props.location.pathname != nextProps.location.pathname) {
      this.props.show();
      setTimeout(() => {
        this.props.hide();
      }, 500);
    }
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.body.classList.remove("gradient-bg");
  }

  __getAboutUsPage() {
    return (
      <section className="about">
        <div className="about-inner">
          <Container fluid>
            <Row className="text-center">
              <Col xs="12">
                <div className="logo-wrap">
                  <img className="img-fluid" src={getLogo()} alt="MobioTV" />
                </div>
                <p className="basic-para">
                  Our Story is about Over-The-Top Content (OTT). Mobio360 is a
                  VR Videos and 360 Streaming site provides the most immersive
                  experience, VR Videos and 360 Photos worldwide to any
                  connected device. Select your VR Videos and 360 Photos to
                  enjoy our international, local and thematic VR Videos and 360
                  Photos that enrich every subscriber’s need.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    );
  }

  __getPrivacyPolicy() {
    let termTitleClass =
      config.lang == "ar" ? "terms-title arabic" : "terms-title";
    return (
      <section className="terms-conditions">
        <Container fluid>
          <Row className="no-gutters">
            <Col xs="12" className="terms-list">
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-desc"
                  defaultMessage="This Privacy Policy explains our commitments and your rights concerning your information.
                                You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, 
                                please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject
                                 to the Terms of Service and governs the same Services and Sites as the ones mentioned in the 
                                 Terms of Service. Any terms we use in the Privacy Policy without defining them have the same 
                                 definition as in the Terms of Service."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-list">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-collect-info-head"
                  defaultMessage="WE COLLECT INFORMATION THE FOLLOWING WAYS:"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-collect-info-desc-one"
                  defaultMessage="1. When you give it to us or give us permission to obtain it If you choose to subscribe to a Service
                                from us, we or the mobile operator of your network will collect your information related to the
                                 payment for the subscription of our Services. Account and billing information collected by the
                                  mobile operator are subject to their respective privacy policies. "
                />
              </p>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-collect-info-desc-two"
                  defaultMessage="2. We get technical information when you visit our Sites and/or Services We may collect technical information
                                    about you whenever you use our Services. We collect log data every time you log in or log out of our Services."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-list">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-how-we-collect-head"
                  defaultMessage="HOW WE USE COLLECTED INFORMATION"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-collect-desc"
                  defaultMessage="We may use your information for the following purposes:"
                />
              </p>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-collect-point-one"
                  defaultMessage="·       Provide the Service(s) you request;"
                />
              </p>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-collect-point-two"
                  defaultMessage="·       Bill and collect for the Service(s) provided to you;"
                />
              </p>
            </Col>
            <Col xs="12" className="terms-list">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-how-long-we-keep-head"
                  defaultMessage="HOW LONG WE KEEP YOUR INFORMATION"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-long-we-keep-desc"
                  defaultMessage="We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
                                    When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-list">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-how-we-protect-head"
                  defaultMessage="HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-protect-desc-one"
                  defaultMessage="We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services."
                />
              </p>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-protect-desc-two"
                  defaultMessage="However, no method of transmission over the internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security. We will continue to enhance our security procedures as new technology becomes available."
                />
              </p>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-how-we-protect-desc-three"
                  defaultMessage="Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-list">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-acceptance-of-policy-head"
                  defaultMessage="ACCEPTANCE OF PRIVACY POLICY"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-acceptance-of-policy-desc"
                  defaultMessage="By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-title">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-change-to-policy-head"
                  defaultMessage="CHANGES TO THIS PRIVACY POLICY"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-change-to-policy-desc"
                  defaultMessage="We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy."
                />
              </p>
            </Col>
            <Col xs="12" className="terms-title">
              <h6 className={termTitleClass}>
                <FormattedMessage
                  id="privacyPolicy-contact-us-head"
                  defaultMessage="CONTACTING US"
                />
              </h6>
              <p className="terms-para">
                <FormattedMessage
                  id="privacyPolicy-contact-us-desc"
                  defaultMessage="If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail to support@content-clubs.com."
                />
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }

  __getTermsConditions() {
    return (
      <section className="terms-conditions">
        <Container fluid>
          <Row className="no-gutters">
            {isAfricatv() ? (
              <div>
                <p className="terms-para">
                  AfricaTV is a subscription service charged at R6/day (1st day
                  free) on Vodacom. Subscribers receive unlimited access to
                  premium mobile content. By using the service you warrant to be
                  18 years or older and that you have the billpayer’s
                  permission. Compatible handsets only. Network fees may apply.
                  You will receive a Welcome Message upon subscription. For
                  help, call 0861131009. To unsubscribe follow the instructions
                  in the content portal. To manage your subscriptions visit the
                  portal or dial *135*997#.
                </p>
                <p className="terms-para">
                  AfricaTV is a service provided by Sam Media B.V, Van
                  Diemenstraat 356, 1013 CR Amsterdam, Netherlands. The service
                  must not be used to intentionally engage in illegal conduct,
                  to knowingly create, store or disseminate any illegal content,
                  to knowingly infringe copyright or intellectual property
                  rights, or to spam or promote the sending of spam. The service
                  provider has the right to terminate the membership or service
                  of any user that does not comply with these terms and
                  conditions. The service provider reserves the right to take
                  down any content that it considers illegal or for which it has
                  received a take-down notice.
                </p>
              </div>
            ) : config.country === "pl" ? (
              <div>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">POSTANOWIENIA OGÓLNE</h6>
                  <p className="terms-para">
                    1. Niniejszy regulamin (zwany dalej „Regulaminem”) określa
                    zasady świadczenia Usług cyfrowych oraz dostarczania przez
                    Internet Treści cyfrowych przeznaczonych na telefony
                    komórkowe, tablety i komputery, oferowanych przez. Sam Media
                    BV 356 1013CN AmsterdamVan Diemenstraat 356, 1013CN
                    Amsterdam Kontakt możliwy jest elektronicznie pod adresem
                    e-mail: pl-mobio360@cchelp.co lub reklamacje@teleaudio.pl
                    oraz na numer telefonu: 22 244 40 22
                  </p>
                  <p className="terms-para">
                    2. Każdy jest zobowiązany do zapoznania się z Regulaminem
                    przed skorzystaniem z Usługi. Korzystanie z Usługi jest
                    możliwe pod warunkiem akceptacji Regulaminu
                  </p>
                  <p className="terms-para">
                    3. Z Usług (zdefiniowanych poniżej) mogą korzystać
                    Użytkownicy sieci następujących operatorów: Orange Polska
                    S.A. (ORANGE), T-Mobile Polska S.A. (T-MOBILE), P4 Sp. z
                    o.o. (PLAY), oraz Polkomtel Sp. z o.o. (PLUS) („Operatorzy”
                    lub „Operator” w zależności od kontekstu).
                  </p>
                  <p className="terms-para">
                    4. Użytkownicy zobowiązani są do korzystania z Usługi oraz z
                    Serwisu w granicach obowiązującego w Polsce prawa oraz
                    zgodnie z postanowieniami niniejszego Regulaminu.
                  </p>
                  <p className="terms-para">
                    5. SAM MEDIA BV nieodpłatnie udostępnia Regulamin w sposób,
                    który umożliwia pozyskanie, odtwarzanie i utrwalanie treści
                    Regulaminu za pomocą systemu teleinformatycznego, którym
                    posługuje się SAM MEDIA BV , a więc na stronie internetowej
                    https://pl.xr-academy.com/. Regulamin dostępny jest także w
                    siedzibie SAM MEDIA BV.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">DEFINICJE</h6>
                  <p className="terms-title">
                    Wskazane poniżej określenia użyte w Regulaminie mają
                    następujące znaczenie:
                  </p>
                  <p className="terms-para">
                    1. Użytkownik – pełnoletnia osoba fizyczna, korzystająca z
                    Usługi na podstawie niniejszego Regulaminu, przy czym osoby
                    o ograniczonej zdolności do czynności prawnych mogą
                    korzystać z Usług pod warunkiem wyrażenia zgody przez
                    przedstawiciela ustawowego, a osoby nieposiadające zdolności
                    do czynności prawnych, pod warunkiem działania w ich imieniu
                    przedstawiciela ustawowego.
                  </p>
                  <p className="terms-para">
                    2. Treść Cyfrowa – dane wytwarzane i dostarczane w postaci
                    cyfrowej wskazane w Serwisie. Baza Treści Cyfrowych
                    oferowanych przez SAM MEDIA BV jest aktualizowana w Serwisie
                    okresowo przez SAM MEDIA BV. Ilości i rodzaj Treści
                    Cyfrowych dostępnych w Serwisie mają charakter zmienny w
                    czasie
                  </p>
                  <p className="terms-para">
                    3. Usługa Cyfrowa – usługa pozwalająca na:
                  </p>
                  <p className="terms-para">
                    a) wytwarzanie, przetwarzanie, przechowywanie lub dostęp do
                    danych wskazanych w Serwisie w postaci cyfrowej;
                  </p>
                  <p className="terms-para">
                    b) wspólne korzystanie z danych wskazanych w Serwisie w
                    postaci cyfrowej, które zostały przesłane lub wytworzone
                    przez Użytkownika lub innych użytkowników tej usługi;
                  </p>
                  <p className="terms-para">
                    c) inne formy interakcji, wskazane w Serwisie, za pomocą
                    danych w postaci cyfrowej.
                  </p>
                  <p className="terms-para">
                    4. Usługa (Usługi) – odpłatne dostarczanie Treści Cyfrowych
                    lub świadczenie Usług Cyfrowych przez SAM MEDIA BV za pomocą
                    Serwisu, na indywidualne żądanie Użytkownika.
                  </p>
                  <p className="terms-para">
                    5. Opłata – określona w chwili złożenia Zamówienia kwota
                    pieniężna, którą Użytkownik zobowiązany jest uiścić za
                    Usługę. Opłata może mieć charakter jednorazowy albo
                    cykliczny w zależności od oferty
                  </p>
                  <p className="terms-para">
                    6. Serwis – platforma multimedialna w sieci Internet, w
                    ramach której możliwe jest korzystanie z Usługi, dostępna
                    pod adresem https://pl.xr-academy.com/
                  </p>
                  <p className="terms-para">
                    7. Umowa – umowa o świadczenie Usługi, zawarta pomiędzy
                    Użytkownikiem i SAM MEDIA BV poprzez akceptację Regulaminu i
                    opisu usługi w Serwisie.
                  </p>
                  <p className="terms-para">
                    8. SMS / wiadomość SMS (Short Message Service) – jest to
                    krótka wiadomość tekstowa, składająca się z nie więcej niż
                    160 znaków (litery, cyfry, znaki szczególne), którą można
                    przesłać na dowolny telefon komórkowy, zawierająca treść
                    wpisaną przez nadawcę.
                  </p>
                  <p className="terms-para">
                    9. Usługa Dostępowa – usługa świadczona przez Operatora na
                    podstawie odpowiedniego regulaminu danego Operatora,
                    umożliwiająca abonentom Operatora (Użytkownikom) zamówienie
                    odpłatnego dostępu do Usługi oraz dokonanie płatności za
                    zamówienie poprzez dodanie należnej opłaty do faktury za
                    zakup usług telekomunikacyjnych danego Operatora (w
                    przypadku abonenta postpaid) lub poprzez odliczenie należnej
                    kwoty od środków zgromadzonych na koncie abonenta (w
                    przypadku abonenta prepaid).
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">ZASADY KORZYSTANIA Z USŁUG</h6>
                  <p className="terms-para">
                    1. Szczegółowy opis Usług oferowanych przez SAM MEDIA BV,
                    wraz z ich cenami dostępne są w Serwisie.
                  </p>
                  <p className="terms-para">
                    2. Z uwagi na fakt, że baza Usług w Serwisie jest
                    aktualizowana okresowo, ich dostępności i opisy mają
                    charakter zmienny w czasie.
                  </p>
                  <p className="terms-para">
                    3. SAM MEDIA BV ma prawo dokonywać aktualizacji i rozwoju
                    funkcjonalności Usług i Serwisu.
                  </p>
                  <p className="terms-para">4. Usługi w Serwisie są płatne.</p>
                  <p className="terms-para">
                    5. Usługę można zakupić jedynie z wykorzystaniem Usługi
                    Dostępowej.
                  </p>
                  <p className="terms-para">
                    6. SAM MEDIA BV może okresowo oferować Usługi w ramach
                    promocji, których warunki i dostępność będą każdorazowo
                    wskazane w Serwisie
                  </p>
                  <p className="terms-para">
                    7. Korzystanie z Usługi wymaga posiadania dostępu do sieci
                    Internet. Opłaty za Usługę nie obejmują kosztów transmisji
                    danych w sieci Internet związanych z korzystaniem z Usługi,
                    które Użytkownik ponosi zgodnie z taryfą Operatora, z usług
                    którego korzysta.
                  </p>
                  <p className="terms-para">
                    8. Usługi dostępne są na terenie Rzeczpospolitej Polskiej.
                    SAM MEDIA BV może także oferować Usługę dla Użytkowników
                    poza terytorium Rzeczypospolitej Polskiej, wówczas przy
                    opisie usługi pojawi się odpowiednia informacja.
                  </p>
                  <p className="terms-para">
                    9. Użytkownicy są uprawnieni do przenoszenia Usług i
                    korzystania z nich także w trakcie czasowego pobytu w innym
                    państwie na terenie Unii Europejskiej lub Europejskiego
                    Obszaru Gospodarczego, jeśli nastąpiła pozytywna weryfikacja
                    rzeczywistego i stałego miejsca zamieszkania na terenie
                    Rzeczpospolitej Polskiej, na zasadach określonych prawem, w
                    tym w oparciu o sprawdzenie adresu IP (protokołu
                    internetowego), z którego Użytkownik uzyskuje dostęp do
                    Usługi oraz posiadanie umowy o świadczenie usług
                    telefonicznych z dostawcą usług świadczonych na terenie
                    Rzeczpospolitej Polskiej.
                  </p>
                  <p className="terms-para">
                    10. Usługa świadczona w ramach korzystania z prawa do
                    przenoszenia Usług w trakcie czasowego pobytu, jest
                    świadczona w takim samym zakresie i na takich samych
                    warunkach jak dostępne dla Użytkownika na terenie
                    Rzeczpospolitej Polskiej.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">SPOSÓB KORZYSTANIA Z USŁUG</h6>
                  <p className="terms-para">
                    1. Zakup Usługi w Serwisie, z wykorzystanym Usługi
                    dostępowej, możliwy jest w następujący sposób:
                  </p>
                  <p className="terms-para">
                    a) Użytkownik wprowadza [1] w Serwisie na stronie
                    aktywacyjnej swój numer telefonu (w przypadku gdy numer
                    Użytkownika zostanie rozpoznany przez system, system sam
                    automatycznie wprowadzi numer telefonu Użytkownika na
                    stronie aktywacyjnej) oraz klika w wyodrębniony przycisk
                    „Przejdź dalej” (lub o podobnej treści). Następnie
                    Użytkownik otrzymuje od Operatora, na numer telefonu który
                    wpisał w Serwisie, bezpłatną wiadomość SMS z unikalnym kodem
                    autoryzacyjnym PIN, który następnie Użytkownik wpisuje
                    również na przedmiotowej stronie i zatwierdza go klikając w
                    wyodrębnione pole „Zamawiam i Płacę” (lub o podobnej treści)
                    albo
                  </p>
                  <p className="terms-para">
                    b) Użytkownik, w przypadku uwierzytelnienia jego numeru
                    telefonu jako należącego do sieci Operatora [2], klika na
                    stronie aktywacyjnej w przycisk „Kliknij, aby zaakceptować
                    regulamin” (lub o podobnej treści), a następnie, aby
                    potwierdzić aktywację, klika w pole „Kliknij, aby zamówić i
                    zapłacić" (lub o podobnej treści).
                  </p>
                  <p className="terms-para">
                    2. Po aktywacji Usługi do Użytkownika wysłana jest bezpłatna
                    wiadomość SMS zawierająca m.in.: potwierdzenie aktywacji
                    Usługi; informacje dotyczące ceny Usługi i częstotliwości
                    przedłużania dostępu do Usługi; link do strony, na której
                    opublikowany jest niniejszy Regulamin; informację o sposobie
                    bezpłatnej dezaktywacji Usługi.
                  </p>
                  <p className="terms-para">
                    3. Dezaktywacji Usługi można dokonać w każdym czasie,
                    wysyłając bezpłatną wiadomość SMS o podanej poniżej treści
                    na wskazany poniżej numer. Dezaktywacja Usługi jest
                    bezpłatna.
                  </p>
                  <p className="terms-para">
                    Operator Komenda dezaktywująca Numer dezaktywujący
                  </p>
                  <p className="terms-para">PLUS STOP MOBIO 80711</p>
                  <p className="terms-para">T-MOBILE STOP MOBIO 80713</p>
                  <p className="terms-para">
                    4. Wiadomość SMS dezaktywującą Usługę należy w każdym
                    przypadku wysłać z numeru telefonu komórkowego, który został
                    użyty przy zamawianiu Usługi.
                  </p>
                  <p className="terms-para">
                    5. Dezaktywacja Usługi skutkuje zakończeniem dostępu do
                    Usługi.
                  </p>
                  <p className="terms-para">
                    6. Od momentu aktywacji Usługi, dostęp do Usługi będzie
                    przedłużany z częstotliwością wybraną przez Użytkownika i
                    według stawek określonych poniżej:
                  </p>
                  <p className="terms-para">
                    Częstotliwość przedłużania dostępu Cena co 7 dni 14,99 zł z
                    vat / co tydzień
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">OPŁATY ZA USŁUGI</h6>
                  <p className="terms-para">
                    1. Użytkownik obciążany jest opłatą, której wysokość wraz z
                    częstotliwością automatycznego przedłużania dostępu została
                    określona w par. 4 ust.6 Regulaminu.
                  </p>
                  <p className="terms-para">
                    2. Opłaty pobierane są przez Operatorów poprzez dodanie
                    opłaty na fakturze za zakup usług telekomunikacyjnych danego
                    Operatora (w przypadku abonenta postpaid) lub poprzez
                    odliczenie należnej kwoty od środków zgromadzonych na koncie
                    abonenta (w przypadku abonenta prepaid).
                  </p>
                  <p className="terms-para">
                    3. Opłaty są cenami brutto i zawierają podatek od towarów i
                    usług (VAT), zgodnie ze stawką określoną obowiązującymi
                    przepisami prawa.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    POZOSTAŁE ZASADY KORZYSTANIA Z USŁUG
                  </h6>
                  <p className="terms-para">
                    1. Możliwość skorzystania przez Użytkownika z Usługi jest
                    uzależniona od należytego wypełnienia przez Użytkownika
                    wymogów wynikających z niniejszego Regulaminu. W
                    szczególności każdy Użytkownik zobowiązany jest zapewnić we
                    własnym zakresie spełnienie następujących minimalnych
                    wymagań technicznych w celu korzystania z Serwisu oraz
                    Usługi:
                  </p>
                  <p className="terms-para">
                    a) telefon komórkowy wyposażony w aktywną kartę SIM w sieci
                    jednego z Operatorów, posiadający funkcjonalności
                    umożliwiające aktywację i korzystanie z Serwisu (w tym
                    odbieranie wiadomości SMS, brak blokad w rozumieniu
                    odpowiedniego regulaminu danego Operatora uniemożliwionych
                    korzystanie z Usługi Dostępowej),
                  </p>
                  <p className="terms-para">b) połączenie z siecią Internet;</p>
                  <p className="terms-para">
                    c) komputer, telefon lub inne urządzenie cyfrowe z
                    zainstalowanym oprogramowaniem pozwalającym na przeglądanie
                    stron internetowych (np.: Internet Explorer 6 i wyższa,
                    Firefox BV 4 i wyższa, Opera 10 i wyższa, Safari 3 i wyższa,
                    Google Chrome), prawidłowo skonfigurowane (w szczególności w
                    zakresie transmisji danych lub innych elementów
                    warunkujących skorzystanie z Usługi);
                  </p>
                  <p className="terms-para">
                    d) prawidłowe skonfigurowanie ww. urządzeń w szczególności w
                    zakresie transmisji danych.
                  </p>
                  <p className="terms-para">
                    2. Użytkownik powinien być uprawniony do korzystania z
                    urządzeń, o których mowa w ust. 1 powyżej w zakresie
                    umożliwiającym mu korzystanie z Serwisu i Usługi.
                  </p>
                  <p className="terms-para">
                    3. Dodatkowe informacje dotyczące funkcjonalności oraz
                    interoperacyjności Usług, w tym kompatybilność z modelem
                    telefonu lub oprogramowaniem komputera, czy innego
                    przeznaczonego urządzenia, na którym Usługi maja zostać
                    odtwarzane, a także ewentualne techniczne środki ich ochrony
                    mogą być również podane w Serwisie przy wybranych przez
                    Użytkownika Usługach.
                  </p>
                  <p className="terms-para">
                    4. Użytkownik powinien chronić hasło i dostęp do swojego
                    telefonu komórkowego/komputera lub konta umożliwiającego
                    korzystanie z Serwisu czy Usług przed nieuprawnionym użyciem
                    przez osoby trzecie.
                  </p>
                  <p className="terms-para">
                    5. Użytkownik uzyskujący dostęp do Usługi ma prawo do
                    korzystania z niej wyłącznie w zakresie określonym w
                    niniejszym Regulaminie tj. w zakresie odtwarzania Usługi na
                    telefonie, komputerze czy innym przeznaczonym do tego
                    urządzeniu. W szczególności Użytkownik nie jest uprawiony do
                    kopiowania, zwielokrotniania, modyfikowania, prezentowania,
                    publikowana, czy rozpowszechniane w jakikolwiek sposób
                    Usługi lub jej części. Użytkownik uzyskuje uprawnienie do
                    korzystania z Usługi w zakresie opisanym powyżej wyłącznie
                    na użytek własny (tj. na użytek osoby, na której rzecz
                    świadczoną jest dana Usługa). W szczególności oznacza to, że
                    niedopuszczalne jest wykorzystywanie Usługi lub jej części w
                    celach komercyjnych, w tym niedopuszczalne jest
                    wykorzystywanie jej na potrzeby prowadzonej działalności
                    gospodarczej, odsprzedaż, ani inne formy udostępniania
                    osobom trzecim.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">OGRANICZENIA. PRAWA AUTORSKIE</h6>
                  <p className="terms-para">
                    1. Mogą wystąpić krótkotrwałe, trwające nie dłużej niż 5
                    godzin miesięcznie, przerwy w dostępie do Usługi,
                    spowodowane prowadzeniem niezbędnych prac konserwacyjnych
                    i/lub technicznych. W przypadku przerw w dostępie,
                    trwających dłużej z powodu awarii, SAM MEDIA BV dołoży
                    starań, aby usunąć awarię w najkrótszym możliwym czasie.
                  </p>

                  <p className="terms-para">
                    2. Usługa dostępna jest z wykorzystaniem teleinformatycznej
                    transmisji danych, w trakcie której mogą zaistnieć,
                    pozostające poza kontrolą SAM MEDIA BV, obiektywne
                    okoliczności i czynniki mające wpływ na możliwość
                    korzystania z Usługi tj. warunki pogodowe, nieprawidłowa
                    instalacja, niedostateczna jakość sygnału, usterka lub
                    awaria sieci teleinformatycznej.
                  </p>

                  <p className="terms-para">
                    3. Usługa posiada licencyjne ograniczenie terytorialne
                    (geolokalizacyjne) i, o ile nie jest inaczej wskazane w
                    opisie danej Usługi, jest dostępna dla Użytkowników
                    logujących się z terytorium Rzeczypospolitej Polskiej
                    (identyfikowanych polskim IP) oraz dla Użytkowników
                    zweryfikowanych pozytywnie jako posiadających rzeczywiste i
                    stałe miejsce zamieszkania w Rzeczypospolitej Polskiej.
                    Prezentacja oferty w Serwisie uwzględnia licencyjne
                    ograniczenia terytorialne dotyczące oferowanych Usług.
                  </p>

                  <p className="terms-para">
                    4. Treści niektórych Usług stanowią utwory podlegające
                    ochronie zgodnie z przepisami obowiązującego prawa. SAM
                    MEDIA BV może stosować systemy autoryzacji oraz szyfrowania
                    Usług. Użytkownik uprawniony jest do korzystania z Usług
                    jedynie do własnego użytku osobistego. Użytkownik nie jest
                    uprawniony do publicznego ani komercyjnego udostępniania
                    Usług lub ich elementów w jakiejkolwiek formie.
                  </p>

                  <p className="terms-para">
                    5. Usługi mogą posiadać (niezależnie od wymagań technicznych
                    określonych w Regulaminie powyżej) ograniczenia o
                    charakterze licencyjnym lub technicznym (w tym ograniczenia
                    sprzętowe), na skutek których Usługi mogą być niedostępne
                    lub ich dostępność może być ograniczona co do określonego
                    rodzaju lub ilości Sprzętu. Informacja o ograniczeniach
                    sprzętowych będzie dostępna w Serwisie przy opisie danej
                    Usługi.
                  </p>

                  <p className="terms-para">
                    6. Ograniczenie możliwości korzystania z Usługi może
                    nastąpić w przypadku próby korzystania z Usługi jednocześnie
                    na kilku Sprzętach (gdy przekroczono dozwoloną liczbę
                    urządzeń) lub w przypadku próby nieautoryzowanego dostępu do
                    Konta Użytkownika w Serwisie.
                  </p>
                  <p className="terms-para">
                    7. Użytkownika obowiązuje zakaz dostarczania treści o
                    charakterze bezprawnym.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">ODPOWIEDZIALNOŚĆ</h6>
                  <p className="terms-para">
                    1. SAM MEDIA BV ponosi odpowiedzialność za brak dostarczenia
                    Usługi w terminie oraz brak zgodności Usługi z Umową.
                  </p>

                  <p className="terms-para">
                    2. Jeżeli Usługa nie została dostarczona w terminie,
                    Użytkownik ma prawo wezwania do jej dostarczenia w trybie
                    reklamacji określonym w § 9. Jeżeli SAM MEDIA BV nie
                    dostarczy Usługi niezwłocznie lub w dodatkowym, wyraźnie
                    uzgodnionym z Użytkownikiem terminie, Użytkownik może
                    odstąpić od Umowy. Użytkownik może odstąpić bez wzywania do
                    dostarczenia Usługi, jeżeli: a) SAM MEDIA BV oświadczył lub
                    z okoliczności wyraźnie wynika, że nie dostarczy Usługi, lub
                    b) Użytkownik i SAM MEDIA BV uzgodnili lub z okoliczności
                    zawarcia Umowy wyraźnie wynika, że określony termin
                    dostarczenia Usługi miał istotne znaczenie dla Użytkownika,
                    a SAM MEDIA BV nie dostarczył jej w tym terminie.
                  </p>

                  <p className="terms-para">
                    3. W przypadku, świadczenia Usługi w sposób niezgodny z
                    Umową, Użytkownik może żądać doprowadzenia Usługi do
                    zgodności z Umową, poprzez złożenie reklamacji, o której
                    mowa w § 9.
                  </p>

                  <p className="terms-para">
                    4. Użytkownik może złożyć oświadczenie o obniżeniu ceny albo
                    o odstąpieniu od Umowy, jeśli zgodnie z odpowiedzią SAM
                    MEDIA BV na żądanie złożone na podstawie ust. 3,
                    doprowadzenie do zgodności Usługi z Umową jest niemożliwe
                    albo wymaga nadmiernych kosztów:
                    <br /> a) SAM MEDIA BV nie doprowadzi Usługi do zgodności z
                    Umową zgodnie z żądaniem złożonym przez Użytkownika; <br />{" "}
                    b) brak zgodności z Umową nadal występuje, mimo że SAM MEDIA
                    BV próbował doprowadzić Usługę do zgodności z Umową
                    stosownie do żądania złożonego na podstawie ust. 3 <br /> c)
                    brak zgodności Usługi z Umową jest na tyle istotny, że
                    uzasadnia natychmiastowe odstąpienie od Umowy; <br /> d) z
                    oświadczenia SAM MEDIA BV złożonego w odpowiedzi na żądanie
                    zgłoszone na podstawie ust. 3, wyraźnie wynika, że Usługa
                    nie zostanie doprowadzona do zgodności z Umową w rozsądnym
                    czasie lub bez nadmiernych niedogodności.
                  </p>

                  <p className="terms-para">
                    5. W przypadku uznania zasadności żądania obniżenia ceny, o
                    którym mowa w ust. 4, SAM MEDIA BV dokona tego obniżenia w
                    proporcji do ceny Usługi wynikającej z Umowy oraz wartości
                    Usługi niezgodnej z umową, z uwzględnieniem czasu jej
                    trwania.
                  </p>

                  <p className="terms-para">
                    6. Uprawnienie do odstąpienia od umowy, o którym mowa w ust.
                    4, nie przysługuje, jeżeli brak zgodności z Umową jest
                    nieistotny.
                  </p>

                  <p className="terms-para">
                    7. SAM MEDIA BV jest uprawniony do odmowy uznania
                    oświadczenia Użytkownika o niezgodności Usługi z Umową m.in.
                    w przypadku gdy: <br /> a) Środowisko cyfrowe Użytkownika
                    nie jest kompatybilne z wymaganiami technicznymi, o których
                    mowa w Umowie; <br /> b) Użytkownik nie wykonuje obowiązku
                    współpracy w celu ustalenia, czy brak zgodności Usługi z
                    Umową w odpowiednim czasie wynika z cech Środowiska
                    cyfrowego Użytkownika.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">REKLAMACJE</h6>
                  <p className="terms-para">
                    1. Użytkownik ma prawo złożyć reklamację.
                  </p>

                  <p className="terms-para">
                    2. Reklamacja może zostać złożona:
                    <br />
                    a) elektronicznie – z wykorzystaniem poczty elektronicznej
                    na adres e-mail pl-mobio360@cchelp.co lub
                    reklamacje@teleaudio.pl........,
                    <br />
                    b) w formie pisemnej – na adres SAM MEDIA BV podany w
                    Regulaminie.
                  </p>

                  <p className="terms-para">
                    3. Reklamacja powinna zawierać:
                    <br />
                    a) imię i nazwisko oraz numer MSISDN wykorzystany do
                    zamówienia Usługi,
                    <br />
                    b) określenie przedmiotu reklamacji oraz okresu będącego
                    przedmiotem reklamacji, przedstawienie okoliczności
                    uzasadniających reklamację, w szczególności wskazanie
                    momentu wystąpienia problemu dotyczącego Usługi,
                    <br />
                    c) podpis Użytkownika – w przypadku reklamacji złożonej w
                    formie pisemnej.
                  </p>

                  <p className="terms-para">
                    4. Reklamacja będzie rozpatrzona w rozsądnym terminie. W
                    przypadkach szczególnie skomplikowanych lub wymagających
                    dodatkowych wyjaśnień rozpatrzenie reklamacji nastąpi nie
                    później niż w ciągu 14 dni od jej otrzymania.
                  </p>

                  <p className="terms-para">
                    5. Odpowiedź na reklamację zostanie udzielona w formie
                    elektronicznej na adres poczty elektronicznej, z którego
                    reklamacja została wysłana przez Użytkownika. W przypadku
                    złożenia reklamacji drogą pisemną Użytkownik powinien
                    wskazać sposób komunikacji z podaniem adresu poczty
                    elektronicznej lub adresu zamieszkania dla odpowiedzi
                    pisemnej.
                  </p>

                  <p className="terms-para">
                    6. SAM MEDIA BV może wezwać Użytkownika do uzupełnienia
                    informacji niezbędnych do rozpatrzenia reklamacji, w
                    szczególności w celu ustalenia czy brak zgodności Usługi z
                    Umową wynika z cech Środowiska cyfrowego Użytkownika. W
                    przypadku braku ich uzupełnienia przez Użytkownika
                    reklamacja pozostawiana jest bez rozpatrzenia. Użytkownik ma
                    obowiązek współpracy w zakresie uzupełnienia danych
                    niezbędnych do rozpatrzenia reklamacji.
                  </p>

                  <p className="terms-para">
                    7. Użytkownik ma prawo dochodzenia roszczeń w postępowaniu
                    sądowym lub w przypadku konsumenta w postępowaniach
                    mediacyjnym lub przed sądem polubownym. Zasady i procedury
                    dostępu do pozasądowego dochodzenia roszczeń przez
                    konsumentów określane są odrębnie w przepisach lub
                    dokumentach powołujących instytucje prowadzące taką
                    działalność lub wydanych przez nie aktach wewnętrznych (np.
                    regulaminy, statuty).
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    POSTANOWIENIA KOŃCOWE. ZMIANY REGULAMINU
                  </h6>
                  <p className="terms-para">
                    1. SAM MEDIA BV jest uprawniony do wprowadzenia zmian
                    Regulaminu.
                  </p>

                  <p className="terms-para">
                    2. Zmiana Regulaminu, która nie jest niezbędna do zachowania
                    zgodności Usługi z Umową może być dokonana w uzasadnionych
                    przypadkach takich jak:
                    <br />
                    a) zmiany przepisów prawa mających wpływ na treść Regulaminu
                    i konieczności dostosowania Regulaminu w celu zachowania
                    jego zgodności z prawem;
                    <br />
                    b) zmian wynikających z konieczności dostosowania Regulaminu
                    do zaleceń, nakazów, orzeczeń, postanowień, interpretacji,
                    wytycznych lub decyzji uprawnionych organów administracji
                    publicznej;
                    <br />
                    c) usprawnienie działania Usługi oraz obsługi Użytkownika;
                    <br />
                    d) zmian związanych z bezpieczeństwem świadczenia Usługi;
                    <br />
                    e) przeciwdziałanie nadużyciom związanym z korzystaniem z
                    Usługi;
                    <br />
                    f) zmian technologicznych i funkcjonalnych Usługi;
                    <br />
                    g) zmiany w zakresie wprowadzania nowych, dodatkowych
                    funkcji, opcji Usługi;
                    <br />
                    h) zmian redakcyjnych związanych z koniecznością poprawy,
                    usunięcia omyłek redakcyjnych, błędów;
                    <br />
                    i) zmian o charakterze administracyjnym, w tym zmian danych
                    identyfikujących lub kontaktowych.
                  </p>

                  <p className="terms-para">
                    3. SAM MEDIA BV poinformuje Użytkowników o zmianach
                    wskazanych w ust. 2 powyżej poprzez opublikowanie informacji
                    o dokonywanych zmianach na stronie
                    https://pl.xr-academy.com/.
                  </p>

                  <p className="terms-para">
                    4. Publikacja nastąpi z 14 dniowym wyprzedzeniem, o ile
                    zachowanie tego terminu jest możliwe ze względu na charakter
                    wprowadzanych zmian.
                  </p>

                  <p className="terms-para">
                    5. W przypadku zmiany Regulaminu, która istotnie i
                    negatywnie wpływa na dostęp lub korzystanie z Usługi, SAM
                    MEDIA BV poinformuje Użytkownika o tej zmianie i terminie
                    jej dokonania z 14 dniowym wyprzedzeniem na trwałym nośniku,
                    o ile zachowanie tego terminu jest możliwe ze względu na
                    charakter wprowadzanych zmian.
                  </p>

                  <p className="terms-para">
                    6. Jeśli Użytkownik nie akceptuje zmian wprowadzonych
                    zgodnie z ust. 5, jest uprawniony do wypowiedzenia Umowy bez
                    zachowania okresu wypowiedzenia, nie później niż w terminie
                    30 dni od dnia dokonania zmiany lub poinformowania o niej,
                    jeżeli poinformowanie nastąpiło później niż ta zmiana.
                  </p>

                  <p className="terms-para">
                    7. Uprawnienie do wypowiedzenia nie przysługuje, jeżeli SAM
                    MEDIA BV zapewnił Użytkownikowi uprawnienie do zachowania,
                    bez dodatkowych kosztów, Usługi zgodnej z Umową, w stanie
                    niezmienionym.
                  </p>

                  <p className="terms-para">
                    8. W sprawach nieuregulowanych Regulaminem stosuje się
                    przepisy obowiązującego prawa.
                  </p>

                  <p className="terms-para">
                    9. SAM MEDIA BV dokłada należytej staranności by chronić
                    prywatność i dane osobowe Użytkowników oraz podejmuje
                    działania podnoszące bezpieczeństwo korzystania z Serwisu
                    oraz usprawniające korzystanie z Serwisu, ale nie ma
                    możliwości całkowitego wyeliminowania wszystkich zagrożeń
                    związanych z korzystaniem z sieci Internet, w tym ryzyka
                    sprzecznej z prawem ingerencji osób nieuprawnionych.
                    Aktualne informacje dotyczące wystąpienia szczególnych
                    zagrożeń związanych z korzystaniem z usług świadczonych
                    drogą elektroniczną, funkcjonalnościach treści cyfrowych
                    oraz środkach ich ochrony są dostępne w Serwisie.
                  </p>

                  <p className="terms-para">
                    10. SAM MEDIA BV jest administratorem danych osobowych
                    Użytkowników. Informacje dotyczące przetwarzania danych
                    osobowych określone zostały w Polityce Prywatności,
                    dostępnej w Serwisie.
                  </p>

                  <p className="terms-para">
                    11. Umowa zawierana jest w języku polskim.
                  </p>

                  <p className="terms-para">
                    12. Niniejsza umowa podlega prawu polskiemu. Wybór prawa
                    obcego nie pozbawia jednak Użytkowników zamawiających Usługi
                    w oparciu o niniejszy Regulamin ich praw wynikających z
                    bezwzględnie obowiązujących przepisów prawa państwa stałego
                    miejsca ich zamieszkania.
                  </p>

                  <p className="terms-para">
                    13. Niniejszy Regulamin wchodzi w życie z dniem 1 Maja
                    2025r.
                  </p>

                  <p className="terms-para">
                    <strong>WZÓR FORMULARZA ODSTĄPIENIA OD UMOWY</strong>
                    <br />
                    (formularz ten należy wypełnić i odesłać tylko w przypadku
                    chęci odstąpienia od Umowy)
                    <br />
                    <br />
                    Adresat: ...
                    <br />
                    Data ...
                    <br />
                    Data zawarcia umowy ...
                    <br />
                    Ja niniejszym informuję o moim odstąpieniu od Umowy ...
                    <br />
                    Imię i nazwisko Użytkownika ...
                    <br />
                    Adres Użytkownika ...
                    <br />
                    Podpis Użytkownika (tylko jeżeli formularz jest przesyłany w
                    wersji papierowej)
                  </p>
                </Col>
              </div>
            ) : (
              <div>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    General Terms And Conditions And Privacy Policy.
                  </h6>
                  <p className="terms-para">
                    The following General Terms and Conditions are applicable to
                    the products and services supplied via WAP, SMS, GPRS and 3G
                    by Sam Media Ltd., or enterprises affiliated to it,
                    (hereinafter to be referred to as “the Provider”). The
                    Provider is permitted to amend these General Terms and
                    Conditions from time to time without notice. Apart from the
                    General Terms and Conditions, any applicable and publicized
                    rules, promotional conditions, guidelines and provisions
                    pertaining to the services also apply to you and the
                    Provider upon the use of the Services (as defined herein) of
                    the Provider. All those guidelines, rules, promotional
                    conditions and provisions will be considered an inextricable
                    part of these General Terms and Conditions. By availing
                    yourself to use the Services of the Provider, you agree to
                    be bound by these General Terms and Conditions and the
                    guidelines, rules and promotional conditions.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Description Of The Provider.</h6>
                  <p className="terms-para">
                    By means of WAP, SMS, GPRS and 3G services, the Provider
                    supplies its user’s access to a network of on-line sources,
                    including on-line games, text messages, rich content and
                    on-line information material which may be downloaded onto
                    mobile telephone or whatsoever devices (“Services”). The
                    General Terms and Conditions are at all times applicable to
                    all new facilities including facilities which the Provider
                    may implement as part of the Provider’s expansion, extension
                    or improvement of the present Services, including any
                    extension to new functions added by the Provider.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Availability.</h6>
                  <p className="terms-para">
                    The Service is supplied as is (at the stage of development
                    it happens to be in) and the Provider accepts no liability
                    nor does it issue any guarantees or warranty in the event
                    that personal configurations, information or messages are
                    not saved, or not saved in due time, or if they are deleted
                    or incorrectly delivered. In order to subscribe to the
                    Service, you are required to have access to the Internet
                    and/or a mobile communications subscription and pay any
                    service fees associated with such access. You are required
                    to pay all expenses incurred in creating such access. You
                    are also responsible for seeing to the connection of any
                    necessary equipment, including any mobile telephone or
                    personal computer or whatever devices that may be necessary
                    needed and are in working order and suitable for use in
                    connection with the Service.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Payment.</h6>
                  <p className="terms-para">
                    You have access to our on-line services free of charge. With
                    regards to the Services and the use of it, you shall pay the
                    amount corresponding to the applicable rates of the Provider
                    in force at that time and according to the rates charged by
                    your mobile operator. The charges shall be invoiced to you
                    via your mobile operator through the mobile bill you receive
                    from the mobile operator of your network. You pay the
                    Provider all national and local or other taxes, including
                    but not restricted to VAT, any taxes or levies imposed in
                    lieu thereof, which taxes are based on the costs due to the
                    use of the Services, regardless of whether those taxes are
                    levied either now or in the future by European, national or
                    local authorities or by any other body or bodies authorized
                    to levy taxes. The Provider reserves the right to change the
                    rates for the Service by posting details of such changes on
                    its website.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Registration Obligation.</h6>
                  <p className="terms-para">
                    In order to warrant safe and secure use of the Service, you
                    guarantee the following, in addition to paying the
                    applicable charges: (a) your personal information
                    (hereinafter to be referred to as the “Registered
                    Information”) provided on the registration form is correct,
                    true, accurate and complete and (b) you agree to ensure that
                    the Registered Information is at all times correct, up to
                    date, true, accurate and complete. If the Provider has a
                    reasonable suspicion that the Registered Information does
                    not reflect a true state of affairs, or is not accurate or
                    complete, then the Provider is entitled to suspend or
                    terminate your account and to withhold both current and
                    future use of the Service, or any component of it. You
                    yourself are responsible for maintaining the secrecy of any
                    passwords and/or accounts issued to you by the Provider, and
                    you are fully liable for all actions carried out involving
                    the use of your password or account. You undertake at the
                    end of each session to close your account (by closing your
                    browser) and to contact the Provider if you notice or
                    suspect that unauthorized use has been made of your password
                    or account, or that security or protection is no longer
                    guaranteed for any other reason. The Provider cannot and
                    will not be liable for any damage arising from your failure
                    to observe the stipulations of this article.
                  </p>
                </Col>
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">
                    Ownership Rights Of The Provider.
                  </h6>
                  <p className="terms-para">
                    You are aware and agree that the Service and software used
                    in connection with the Service, (hereinafter to be referred
                    to as the “Software”), contain confidential information
                    which belongs to the Provider is protected by valid and
                    applicable intellectual and industrial ownership rights
                    legislation and other legislation. You are also aware and
                    agree that copyright, trademarks, service marks, patents or
                    other ownership rights and laws are applicable to
                    Information published in sponsors' advertisements or
                    information offered to you via the Service. You undertake,
                    either partially or wholly, not to amend, rent, rent out,
                    borrow, lend, sell, distribute or create products derived
                    from the Service or the Software except in the event that
                    the Provider has given you explicit written permission to do
                    so. The Provider hereby grants you a personal,
                    non-transferable and non-exclusive right and permission to
                    use the working code of its Software, provided you do not
                    copy or alter any source code whatever, or create a product
                    derived from it, or carry out any reverse engineering or
                    reverse assembly on it or in any other way attempt to find a
                    source code (or permit third parties to do so) (except if
                    and insofar as such acts are permitted by the provisions of
                    any mandatory law that may be in effect), and you agree not
                    sell, encode, sublicense, encumber with security rights or
                    transfer in any other way any rights connected with the
                    Software to any person or entity. You undertake not to alter
                    the Software in any way whatever or to use any altered
                    versions of the Software for the purpose of gaining
                    unauthorized access to the Service or for any other reason.
                    In gaining access to the Service, you undertake only to make
                    use of the interface supplied for that purpose by the
                    Provider. The Provider hereby grants you permission to make
                    one copy only of the Information on the equipment you use
                    for gaining access to the Service, and to use and display
                    the copy of the Information made on that equipment for
                    private purposes.
                  </p>
                </Col>
              </div>
            )}
          </Row>
        </Container>
      </section>
    );
  }

  render() {
    switch (this.state.type) {
      case "about": {
        return this.__getAboutUsPage();
      }
      case "privacy-policy": {
        return this.__getPrivacyPolicy();
      }
      case "terms-conditions": {
        return this.__getTermsConditions();
      }
      default:
        return <section></section>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      setHeaderTitle,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StaticPages);



// WEBPACK FOOTER //
// ./src/components/StaticPages/StaticPages.js